import React, { useEffect, useState, useMemo } from "react";
import { io } from "socket.io-client";
import TachesEnAttente from "../components/TachesEnAttente";
import { getBackendToken } from "../utils/authUtils";
// import FichierExcel from "../components/FichierExcel";

const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); 
// // Adapter l'URL si nécessaire

function Taches({
  user,
  loading,
  checkGroupAdresse,
  checkGroupNom,
  checkGroupAdmin,
  checkGroupReseauInfo,
  checkGroupInfoBancaire,
  checkGroupAntCriminels,
  checkGroupRecMensuelle,
  checkGroupSeancePlacement,
  checkGroupTeletravail,
  checkGroupConsultationAchatEI
}) {
  const [demandeEnAttente, setDemandeEnAttente] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filterNom, setFilterNom] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // État pour le filtre de statut
  const [lieuFilter, setLieuFilter] = useState(""); 
  const [assigneFilter, setAssigneFilter] = useState("");
  const [nomFormulaire, setNomFormulaire] = useState("");
  const [periodeReclamation, setPeriodeReclamation] = useState("");
  const [acceptedByFilter, setAcceptedByFilter] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1); // Page actuelle
  const [authLoading, setAuthLoading] = useState(true);
  const [messageErreurNom, setMessageErreurNom] = useState('');
  const [messageErreur, setMessageErreur] = useState('');
  const [messageErreurDate, setMessageErreurDate] = useState('');
  const [shouldFetch, setShouldFetch] = useState(false);


    // ✅ Memoize groups pour éviter leur recréation à chaque render
  const groups = useMemo(() => [
    { name: "group Adresse", check: checkGroupAdresse },
    { name: "group Nom", check: checkGroupNom },
    { name: "group admin", check: checkGroupAdmin },
    { name: "group ReseauInfo", check: checkGroupReseauInfo },
    { name: "group InfoBancaire", check: checkGroupInfoBancaire },
    { name: "group AntCriminels", check: checkGroupAntCriminels },
    { name: "group RecMensuelle", check: true },
    { name: "group Finance", check: checkGroupRecMensuelle },
    { name: "group SeancePlacement", check: checkGroupSeancePlacement },
    { name: "group Teletravail", check: checkGroupTeletravail },
    { name: "group ConsultationAchatEI", check: checkGroupConsultationAchatEI },
  ], [
    checkGroupAdresse,
    checkGroupNom,
    checkGroupAdmin,
    checkGroupReseauInfo,
    checkGroupInfoBancaire,
    checkGroupAntCriminels,
    checkGroupRecMensuelle,
    checkGroupSeancePlacement,
    checkGroupTeletravail,
    checkGroupConsultationAchatEI
  ]);

  // ✅ Memoize userGroups
  const userGroups = useMemo(() => {
    return groups.filter((group) => group.check).map((group) => group.name);
  }, [groups]);

  useEffect(() => {
  if (user && userGroups.length > 0) {
    // Vérifier la longueur du nom si un filtre nom est saisi
     // Vérifier que les deux dates sont renseignées

      // Réinitialiser le flag
    setShouldFetch(false);

      if ((!startDate && endDate)) {
      setMessageErreurDate("Veuillez renseigner à la fois la date de début et la date de fin.");
      return;
    }

      const start = new Date(startDate);
      const end = endDate ? new Date(endDate) : new Date(); 

      // Vérifier que la date de fin est après la date de début
      if (end < start) {
        setMessageErreurDate("La date de fin doit être postérieure à la date de début.");
        return;
      }

      // Calcul de la différence en mois
      const diffMonths =
        (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

      // Vérifier que la période ne dépasse pas 6 mois
      if (!(filterNom || filterValue) && (diffMonths > 6 || (diffMonths === 6 && end.getDate() > start.getDate()))) {
        setMessageErreurDate("La période entre les deux dates ne doit pas dépasser 6 mois.");
        return;
      }

      if (filterNom && filterNom.length < 3) {
        setMessageErreurNom("Le nom doit contenir au moins 4 caractères pour effectuer la recherche.");
        return;
      }
      // Vérifier que filterValue contient au moins 4 chiffres
    if (filterValue && filterValue.replace(/\D/g, '').length < 4) {
        setMessageErreur("La valeur doit contenir au moins 4 chiffres pour effectuer la recherche.");
        return;
    }

      setMessageErreurNom("")
      setMessageErreur("")
      setMessageErreurDate("")

    setCurrentPage(1);
    const fetchData = async () => {
      try {
      
      const token = await getBackendToken(); // get Microsoft token

      socket.emit("fetchData", {
        startDate,
        endDate,
        filterValue,
        filterNom,
        statusFilter,
        lieuFilter,
        assigneFilter,
        nomFormulaire,
        periodeReclamation,
        acceptedByFilter,
        token,
      });
     } catch (error) {
        console.error("Erreur lors de la récupération du token:", error);
      }
    };

    fetchData(); // initial fetch

    // Listen for updates from server
    socket.on("updateData", (data) => {
      setDemandeEnAttente(data.demandes);
      // setTotalPages(data.totalPages);
      setAuthLoading(false); 
    });

    // Trigger fetchData when a request is updated
    socket.on("requestUpdated", () => {
      fetchData();
    });

    socket.on("error", (err) => console.error("Socket error:", err));

    return () => {
      socket.off("updateData");
      socket.off("requestUpdated");
      socket.off("error");
      
    };
  }
}, [
  user,
  // startDate,
  // endDate,
  // filterValue,
  // filterNom,
  // statusFilter,
  // nomFormulaire,
  // acceptedByFilter,
  shouldFetch // 👈 important !
  // currentPage
]);




  if (!user) {
    return <div>No user data available.</div>;
  }

  return (
    <div className="min-h-screen p-4">
      <TachesEnAttente
        user={user}
        socket={socket}
        setAuthLoading={setAuthLoading}
        authLoading={authLoading}
        demandeEnAttente={demandeEnAttente}
        checkGroupAdmin={checkGroupAdmin}
        checkGroupRecMensuelle={checkGroupRecMensuelle}
        checkGroupSeancePlacement={checkGroupSeancePlacement}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        setTotalPages={setTotalPages}
        filterNom ={filterNom} 
        setFilterNom ={setFilterNom}
        acceptedByFilter ={acceptedByFilter} 
        setAcceptedByFilter ={setAcceptedByFilter}
        nomFormulaire ={nomFormulaire} 
        setNomFormulaire ={setNomFormulaire}
        periodeReclamation={periodeReclamation}
        setPeriodeReclamation={setPeriodeReclamation}
        statusFilter ={statusFilter}
        setStatusFilter ={setStatusFilter}
        lieuFilter ={lieuFilter}
        setLieuFilter ={setLieuFilter}
        assigneFilter ={assigneFilter}
        setAssigneFilter ={setAssigneFilter}
        messageErreurNom={messageErreurNom}
        messageErreur={messageErreur}
        messageErreurDate={messageErreurDate}
        setShouldFetch ={setShouldFetch}
      />
    </div>
  );
}

export default Taches;
// const fetchData = useCallback(async () => {
//   if (!user || userGroups.length === 0) return;

//   const queryParams = new URLSearchParams({
//     userId: user.id,
//     groups: JSON.stringify(userGroups), // send groups as JSON (or CSV if backend expects that)
//     ...(startDate ? { startDate } : {}),
//     ...(endDate ? { endDate } : {}),
//     ...(filterValue ? { filterValue } : {}),
//     ...(filterNom ? { filterNom } : {}),
//     ...(statusFilter ? { statusFilter } : {}),
//     ...(nomFormulaire ? { nomFormulaire } : {}),
//     ...(acceptedByFilter ? { acceptedByFilter } : {}),
//     currentPage,
//   });

//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_API_BASE_URL}/taches?${queryParams.toString()}`
//     );
//     if (!response.ok) throw new Error("Erreur lors de la récupération des données.");

//     const data = await response.json();
//     console.log("data render")
//     setDemandeEnAttente(data.demandes);
//     setTotalPages(data.totalPages);
//   } catch (error) {
//     console.error("Erreur :", error);
//   }
// }, [
//   user,
//   userGroups,
//   startDate,
//   endDate,
//   filterValue,
//   filterNom,
//   statusFilter,
//   nomFormulaire,
//   acceptedByFilter,
//   currentPage,
// ]);

// useEffect(() => {
//   fetchData();
// }, [fetchData]);